import { AIResultDisplayModel } from './AIResultMapper'
import { AIFeature, RoomSession } from '@zocks-communications/client-sdk-js'
import { AiFeature } from '../../../models/AiFeature'
import { RoomSession as _RoomSession } from '../../../models/Room'
import { AiResult } from '../../../models/AiResult'
import { User } from '../../../models/User'

export const getRoomTrackingDetails = (roomSession?: RoomSession | _RoomSession | null) => {
  const { roomId = '', id: sessionId = '' } = roomSession ?? {}
  return {
    roomId,
    sessionId,
  }
}

export const getRoomTrackingDetailsForAiResult = (aiResult?: AiResult | null) => {
  const { roomId = '', sessionId = '' } = aiResult ?? {}
  return {
    roomId,
    sessionId,
  }
}

export const getRoomAndAIFeatureTrackingDetails = (roomSession: RoomSession | _RoomSession | null, aiFeature: AIFeature | AiFeature) => {
  const { roomId = '', id: sessionId = '' } = roomSession ?? {}
  const { id: aiFeatureId, preset: { id: aiFeaturePresetId } = {} } = aiFeature
  return {
    roomId,
    sessionId,
    aiFeatureId,
    aiFeaturePresetId,
  }
}

export const getRoomAndAIFeaturesTrackingDetails = (roomSession: RoomSession | _RoomSession | null, aiFeatureIds: string[]) => {
  const { roomId = '', id: sessionId = '' } = roomSession ?? {}
  return {
    roomId,
    sessionId,
    aiFeatureIds,
  }
}

export const getAIResultTrackingDetails = (aiResult: AIResultDisplayModel, options?: { withResult: boolean }) => {
  const withResult = options?.withResult ?? true
  const { aiResultId, result } = aiResult
  return {
    aiResultId,
    ...(withResult && { result }),
  }
}

export const getAIFeatureAndResultTrackingDetails = (aiFeature: AiFeature, aiResult: AiResult) => {
  const { id: aiFeatureId, preset: { id: aiFeaturePresetId } = {} } = aiFeature
  const { id: aiResultId, roomId, sessionId } = aiResult
  return {
    roomId,
    sessionId,
    aiFeatureId,
    aiFeaturePresetId,
    aiResultId,
  }
}

export const getDynamicContextTrackingDetails = (data: any) => {
  const { formData } = data
  return { context: formData }
}

export const getIntegrationUserTrackingDetails = (integrationUser: User | null) => {
  const { serviceId = null, externalId = null } = integrationUser?.integrations?.length ? integrationUser.integrations[0] : {}
  return { serviceId, externalId }
}
